import { render } from "./Select.vue?vue&type=template&id=2fca8295"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"
script.render = render

export default script